export default __webpack_public_path__ + "static/media/微電網.b3c87f50.gif";